// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variables */
.fixed-top {
  position: absolute !important;
}
.navbar-dark {
  background-color: #cc0000;
}
/* change the brand and text color */
.navbar-dark .navbar-brand,
.navbar-custom .navbar-text {
  color: rgba(255, 255, 255, 0.8);
}
/* change the link color */
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}
/* change the color of active or hovered links */
.navbar-dark .nav-item.active .nav-link,
.navbar-dark .nav-item:hover .nav-link {
  color: #ffffff;
}
li.see-history {
  color: #cc0000 !important;
  text-decoration: none !important;
  border-bottom: none !important;
  cursor: default !important;
  position: relative;
}
span.arrow-right {
  width: 0px;
  height: 0px;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid #cc0000;
  position: absolute;
  left: 103%;
  margin-top: 3px !important;
}
#staticPunchLine {
  position: absolute;
  top: 20px;
  right: 25px;
  color: #ffffff;
  z-index: 9999;
}
.navbar {
  padding: 0 1rem;
}
#navbarText ul {
  display: flex;
}
#navbarText ul li {
  display: inline-flex;
  padding: 0 20px;
  border-left: 1px solid #B5965E;
}
#navbarText ul li:first-child {
  border-left-width: 0;
  padding-left: 0;
}
#navbarText ul li:last-child {
  padding-right: 0;
}
.loginPage {
  color: #B5965E;
}
.loginPage:hover {
  color: #FFA500;
  text-decoration: underline;
}
header.ShareSvtLocationHeader {
  min-height: auto !important;
  text-align: center;
}
.add-cursor {
  cursor: pointer;
}
.nav-big-header {
  height: 5.5rem;
  line-height: normal;
}
.height-3 {
  height: 3.8rem !important;
}
.hcil-header-nave {
  padding-top: 10px;
  padding-left: 30px;
  padding-right: 30px;
}
.navbar-brand {
  padding: 15px 0 15px 55px;
  float: left;
}
.navbar-brand img {
  width: 165px;
}
@media (max-width: 667.98px) {
  .navbar-brand {
    padding: 10px 0 10px 15px;
  }
}
nav .header-details {
  width: 100%;
}
nav .header-details .search {
  float: right;
  margin: 12px;
  border-right: 1px solid #B1B1B1;
}
nav .header-details .search input {
  background-color: transparent;
  border: none;
  border-radius: 5px;
  color: #ffffff;
  padding: 5px 5px 5px 35px;
  width: 100px;
  outline: none;
  margin-right: 12px;
  background-image: url('/assets/images/ico_search.svg');
  background-repeat: no-repeat;
  background-size: 16px;
  background-position: 8px center;
}
nav .header-details .search ::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #ffffff;
  opacity: 1;
  /* Firefox */
  font-size: 14px;
}
nav .header-details .search input:not(:placeholder-shown) {
  background-color: #313131;
  width: 350px;
  margin-right: 12px;
}
nav .header-details .search:hover input {
  background-color: #313131;
  width: 350px;
  margin-right: 12px;
  transition: 0.75s;
}
nav .header-details .usermenu {
  float: right;
}
nav .header-details .usermenu .dropdown-toggle {
  background-color: transparent;
  color: #ffffff;
  font-size: 16px;
  text-transform: capitalize;
  opacity: 0.75;
  padding: 10px;
  line-height: 16px;
  outline: none;
}
nav .header-details .usermenu .dropdown-toggle span {
  font-size: 12px;
}
nav .header-details .usermenu .dropdown-toggle:hover {
  opacity: 1;
}
nav .header-details .usermenu .dropdown-toggle:focus {
  border-color: transparent;
  box-shadow: none;
}
nav .header-details .usermenu .dropdown-menu {
  background-color: #313131;
  padding: 0;
}
nav .header-details .usermenu .dropdown-menu .dropdown-item {
  color: #ffffff;
  padding: 8px 10px;
  font-size: 14px;
}
nav .header-details .usermenu .dropdown-menu .dropdown-item:hover {
  background-color: #cc0000;
}
.sub-nav {
  height: 40px;
  top: 100px;
  left: 0;
  position: absolute;
  z-index: 1029;
  width: 100%;
  background-color: #313131;
}
.sub-nav .dashboard-log {
  cursor: pointer;
}
.sub-nav .dashboard-log img {
  float: left;
  width: 16px;
  margin: 13px 8px 0 32px;
}
.sub-nav .dashboard-log h5 {
  color: #cc0000;
  font-size: 18px;
  float: left;
  margin: 11px 0;
}
.sub-nav .dashboard-menu ul {
  float: left;
  padding: 0 2px;
}
.sub-nav .dashboard-menu ul li {
  color: #ffffff;
  list-style: none;
  display: inline-block;
  margin: 0 5px;
  padding: 13px 1px;
  border-bottom: 3px solid transparent;
  font-size: 12px;
  cursor: pointer;
}
.sub-nav .dashboard-menu ul li:hover {
  color: #cc0000;
  border-bottom: 3px solid #cc0000;
}
.sub-nav .dashboard-menu ul li.selected {
  color: #cc0000;
  border-bottom: 3px solid #cc0000;
}
.bar_div {
  display: block;
  width: 100%;
  height: 50px;
  position: absolute;
  left: 0;
  top: 64px;
  background-color: #cc0000;
}
.telephony_frame {
  width: 100%;
  height: 40px;
  right: 0;
  border: unset;
}
.crm_frame {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  border: none;
}
.bar_button {
  background-color: #3C8DBC;
  color: white;
  border: solid black 0px;
  cursor: pointer;
  padding: 4px;
  font-weight: bold;
}
table {
  border-collapse: collapse;
  width: 100%;
  border-radius: 10px 10px 0 0;
  box-shadow: 0 -1px 22px -1px #C6C6C6;
  box-sizing: border-box;
}
td {
  text-align: left;
  padding: 8px;
}
th {
  text-align: center;
  padding: 8px;
  background-color: #3C8DBC;
  color: white;
  border-radius: 10px 10px 0 0;
  box-shadow: 0 -1px 22px -1px #C6C6C6;
  box-sizing: border-box;
}
tr:nth-child(even) {
  background-color: #f2eded;
}
tr:nth-child(odd) {
  background-color: #e8e3e3;
}
button.dlrtkt {
  background: none;
  color: #ffffff;
  border: none;
  margin-top: 9px;
  margin-left: 12px;
  font-size: 12px;
}
.dashboard_dealer_ticket {
  float: left;
  font-size: 12px;
  padding: 3px;
}
/*# sourceMappingURL=nav-big.component.css.map */`, "",{"version":3,"sources":["webpack://./src/app/layout/nav-big/nav-big.component.less","webpack://./nav-big.component.less"],"names":[],"mappings":"AAAA,cAAc;ACCd;EACE,6BAAA;ADCF;ACCA;EACE,yBAAA;ADCF;AACA,oCAAoC;ACEpC;;EAEE,+BAAA;ADAF;AACA,0BAA0B;ACG1B;EACE,+BAAA;ADDF;AACA,gDAAgD;ACIhD;;EAEE,cAAA;ADFF;ACKA;EACE,yBAAA;EACA,gCAAA;EACA,8BAAA;EACA,0BAAA;EACA,kBAAA;ADHF;ACMA;EACE,UAAA;EACA,WAAA;EACA,iCAAA;EACA,oCAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;EACA,0BAAA;ADJF;ACOA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;ADLF;ACOA;EACE,eAAA;ADLF;ACOA;EAEI,aAAA;ADNJ;ACIA;EAKM,oBAAA;EACA,eAAA;EACA,8BAAA;ADNN;ACQM;EACE,oBAAA;EACA,eAAA;ADNR;ACSM;EACE,gBAAA;ADPR;ACaA;EACE,cAAA;ADXF;ACcA;EACE,cAAA;EACA,0BAAA;ADZF;ACeA;EACE,2BAAA;EACA,kBAAA;ADbF;ACgBA;EACE,eAAA;ADdF;ACiBA;EACE,cAAA;EACA,mBAAA;ADfF;ACkBA;EACE,yBAAA;ADhBF;ACmBA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;ADjBF;ACmBA;EACE,yBAAA;EACA,WAAA;ADjBF;ACeA;EAII,YAAA;ADhBJ;ACkBE;EAAA;IACE,yBAAA;EDfF;AACF;ACkBA;EAEI,WAAA;ADjBJ;ACeA;EAIM,YAAA;EACA,YAAA;EACA,+BAAA;ADhBN;ACUA;EAQQ,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,sDAAA;EACA,4BAAA;EACA,qBAAA;EACA,+BAAA;ADfR;ACJA;EDME,yCAAyC;ECgBnC,cAAA;EACA,UAAA;EDdN,YAAY;ECeN,eAAA;ADbR;ACXA;EA2BQ,yBAAA;EACA,YAAA;EACA,kBAAA;ADbR;ACgBM;EAEI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;ADfV;ACtBA;EA0CM,YAAA;ADjBN;ACzBA;EA4CQ,6BAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,aAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;ADhBR;ACnCA;EAqDU,eAAA;ADfV;ACiBQ;EACE,UAAA;ADfV;ACiBQ;EACE,yBAAA;EACA,gBAAA;ADfV;AC7CA;EAgEQ,yBAAA;EACA,UAAA;ADhBR;ACjDA;EAmEU,cAAA;EACA,iBAAA;EACA,eAAA;ADfV;ACgBU;EACE,yBAAA;ADdZ;ACqBA;EACE,YAAA;EACA,UAAA;EACA,OAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,yBAAA;ADnBF;ACYA;EASI,eAAA;ADlBJ;ACSA;EAWM,WAAA;EACA,WAAA;EACA,uBAAA;ADjBN;ACIA;EAgBM,cAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;ADjBN;ACFA;EAwBM,WAAA;EACA,cAAA;ADnBN;ACNA;EA2BQ,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,iBAAA;EACA,oCAAA;EACA,eAAA;EACA,eAAA;ADlBR;ACmBQ;EACE,cAAA;EACA,gCAAA;ADjBV;ACmBQ;EACE,cAAA;EACA,gCAAA;ADjBV;ACwBA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,yBAAA;ADtBF;ACyBA;EACE,WAAA;EACA,YAAA;EACA,QAAA;EACA,aAAA;ADvBF;AC0BA;EACE,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;ADxBF;AC2BA;EACE,yBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;ADzBF;AC4BA;EACE,yBAAA;EACA,WAAA;EACA,4BAAA;EACA,oCAAA;EACA,sBAAA;AD1BF;AC6BA;EACE,gBAAA;EACA,YAAA;AD3BF;AC8BA;EACE,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,4BAAA;EACA,oCAAA;EACA,sBAAA;AD5BF;AC+BA;EACE,yBAAA;AD7BF;ACgCA;EACE,yBAAA;AD9BF;ACgCA;EACE,gBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AD9BF;ACgCA;EACE,WAAA;EACA,eAAA;EACA,YAAA;AD9BF;AACA,gDAAgD","sourcesContent":["/* Variables */\n.fixed-top {\n  position: absolute !important;\n}\n.navbar-dark {\n  background-color: #cc0000;\n}\n/* change the brand and text color */\n.navbar-dark .navbar-brand,\n.navbar-custom .navbar-text {\n  color: rgba(255, 255, 255, 0.8);\n}\n/* change the link color */\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.5);\n}\n/* change the color of active or hovered links */\n.navbar-dark .nav-item.active .nav-link,\n.navbar-dark .nav-item:hover .nav-link {\n  color: #ffffff;\n}\nli.see-history {\n  color: #cc0000 !important;\n  text-decoration: none !important;\n  border-bottom: none !important;\n  cursor: default !important;\n  position: relative;\n}\nspan.arrow-right {\n  width: 0px;\n  height: 0px;\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 5px solid #cc0000;\n  position: absolute;\n  left: 103%;\n  margin-top: 3px !important;\n}\n#staticPunchLine {\n  position: absolute;\n  top: 20px;\n  right: 25px;\n  color: #ffffff;\n  z-index: 9999;\n}\n.navbar {\n  padding: 0 1rem;\n}\n#navbarText ul {\n  display: flex;\n}\n#navbarText ul li {\n  display: inline-flex;\n  padding: 0 20px;\n  border-left: 1px solid #B5965E;\n}\n#navbarText ul li:first-child {\n  border-left-width: 0;\n  padding-left: 0;\n}\n#navbarText ul li:last-child {\n  padding-right: 0;\n}\n.loginPage {\n  color: #B5965E;\n}\n.loginPage:hover {\n  color: #FFA500;\n  text-decoration: underline;\n}\nheader.ShareSvtLocationHeader {\n  min-height: auto !important;\n  text-align: center;\n}\n.add-cursor {\n  cursor: pointer;\n}\n.nav-big-header {\n  height: 5.5rem;\n  line-height: normal;\n}\n.height-3 {\n  height: 3.8rem !important;\n}\n.hcil-header-nave {\n  padding-top: 10px;\n  padding-left: 30px;\n  padding-right: 30px;\n}\n.navbar-brand {\n  padding: 15px 0 15px 55px;\n  float: left;\n}\n.navbar-brand img {\n  width: 165px;\n}\n@media (max-width: 667.98px) {\n  .navbar-brand {\n    padding: 10px 0 10px 15px;\n  }\n}\nnav .header-details {\n  width: 100%;\n}\nnav .header-details .search {\n  float: right;\n  margin: 12px;\n  border-right: 1px solid #B1B1B1;\n}\nnav .header-details .search input {\n  background-color: transparent;\n  border: none;\n  border-radius: 5px;\n  color: #ffffff;\n  padding: 5px 5px 5px 35px;\n  width: 100px;\n  outline: none;\n  margin-right: 12px;\n  background-image: url('/assets/images/ico_search.svg');\n  background-repeat: no-repeat;\n  background-size: 16px;\n  background-position: 8px center;\n}\nnav .header-details .search ::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  color: #ffffff;\n  opacity: 1;\n  /* Firefox */\n  font-size: 14px;\n}\nnav .header-details .search input:not(:placeholder-shown) {\n  background-color: #313131;\n  width: 350px;\n  margin-right: 12px;\n}\nnav .header-details .search:hover input {\n  background-color: #313131;\n  width: 350px;\n  margin-right: 12px;\n  transition: 0.75s;\n}\nnav .header-details .usermenu {\n  float: right;\n}\nnav .header-details .usermenu .dropdown-toggle {\n  background-color: transparent;\n  color: #ffffff;\n  font-size: 16px;\n  text-transform: capitalize;\n  opacity: 0.75;\n  padding: 10px;\n  line-height: 16px;\n  outline: none;\n}\nnav .header-details .usermenu .dropdown-toggle span {\n  font-size: 12px;\n}\nnav .header-details .usermenu .dropdown-toggle:hover {\n  opacity: 1;\n}\nnav .header-details .usermenu .dropdown-toggle:focus {\n  border-color: transparent;\n  box-shadow: none;\n}\nnav .header-details .usermenu .dropdown-menu {\n  background-color: #313131;\n  padding: 0;\n}\nnav .header-details .usermenu .dropdown-menu .dropdown-item {\n  color: #ffffff;\n  padding: 8px 10px;\n  font-size: 14px;\n}\nnav .header-details .usermenu .dropdown-menu .dropdown-item:hover {\n  background-color: #cc0000;\n}\n.sub-nav {\n  height: 40px;\n  top: 100px;\n  left: 0;\n  position: absolute;\n  z-index: 1029;\n  width: 100%;\n  background-color: #313131;\n}\n.sub-nav .dashboard-log {\n  cursor: pointer;\n}\n.sub-nav .dashboard-log img {\n  float: left;\n  width: 16px;\n  margin: 13px 8px 0 32px;\n}\n.sub-nav .dashboard-log h5 {\n  color: #cc0000;\n  font-size: 18px;\n  float: left;\n  margin: 11px 0;\n}\n.sub-nav .dashboard-menu ul {\n  float: left;\n  padding: 0 2px;\n}\n.sub-nav .dashboard-menu ul li {\n  color: #ffffff;\n  list-style: none;\n  display: inline-block;\n  margin: 0 5px;\n  padding: 13px 1px;\n  border-bottom: 3px solid transparent;\n  font-size: 12px;\n  cursor: pointer;\n}\n.sub-nav .dashboard-menu ul li:hover {\n  color: #cc0000;\n  border-bottom: 3px solid #cc0000;\n}\n.sub-nav .dashboard-menu ul li.selected {\n  color: #cc0000;\n  border-bottom: 3px solid #cc0000;\n}\n.bar_div {\n  display: block;\n  width: 100%;\n  height: 50px;\n  position: absolute;\n  left: 0;\n  top: 64px;\n  background-color: #cc0000;\n}\n.telephony_frame {\n  width: 100%;\n  height: 40px;\n  right: 0;\n  border: unset;\n}\n.crm_frame {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  border: none;\n}\n.bar_button {\n  background-color: #3C8DBC;\n  color: white;\n  border: solid black 0px;\n  cursor: pointer;\n  padding: 4px;\n  font-weight: bold;\n}\ntable {\n  border-collapse: collapse;\n  width: 100%;\n  border-radius: 10px 10px 0 0;\n  box-shadow: 0 -1px 22px -1px #C6C6C6;\n  box-sizing: border-box;\n}\ntd {\n  text-align: left;\n  padding: 8px;\n}\nth {\n  text-align: center;\n  padding: 8px;\n  background-color: #3C8DBC;\n  color: white;\n  border-radius: 10px 10px 0 0;\n  box-shadow: 0 -1px 22px -1px #C6C6C6;\n  box-sizing: border-box;\n}\ntr:nth-child(even) {\n  background-color: #f2eded;\n}\ntr:nth-child(odd) {\n  background-color: #e8e3e3;\n}\nbutton.dlrtkt {\n  background: none;\n  color: #ffffff;\n  border: none;\n  margin-top: 9px;\n  margin-left: 12px;\n  font-size: 12px;\n}\n.dashboard_dealer_ticket {\n  float: left;\n  font-size: 12px;\n  padding: 3px;\n}\n/*# sourceMappingURL=nav-big.component.css.map */","@import '../../../assets/css/constant.less';\n.fixed-top{\n  position: absolute !important;\n}\n.navbar-dark {\n  background-color: @brand-color;\n}\n\n/* change the brand and text color */\n.navbar-dark .navbar-brand,\n.navbar-custom .navbar-text {\n  color: rgba(255, 255, 255, .8);\n}\n\n/* change the link color */\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, .5);\n}\n\n/* change the color of active or hovered links */\n.navbar-dark .nav-item.active .nav-link,\n.navbar-dark .nav-item:hover .nav-link {\n  color: @white;\n}\n\nli.see-history {\n  color: @brand-color !important;\n  text-decoration: none !important;\n  border-bottom: none !important;\n  cursor: default !important;\n  position: relative;\n}\n\nspan.arrow-right {\n  width: 0px;\n  height: 0px;\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 5px solid @brand-color;\n  position: absolute;\n  left: 103%;\n  margin-top: 3px !important;\n}\n\n#staticPunchLine {\n  position: absolute;\n  top: 20px;\n  right: 25px;\n  color: @white;\n  z-index: 9999;\n}\n.navbar {\n  padding: 0 1rem;\n}\n#navbarText{\n  ul {\n    display: flex;\n\n    li {\n      display: inline-flex;\n      padding: 0 20px;\n      border-left: 1px solid @link;\n\n      &:first-child {\n        border-left-width: 0;\n        padding-left: 0;\n      }\n\n      &:last-child {\n        padding-right: 0;\n      }\n    }\n  }\n}\n\n.loginPage{\n  color:  @link;\n}\n\n.loginPage:hover{\n  color: @orange;\n  text-decoration: underline;\n}\n\nheader.ShareSvtLocationHeader{\n  min-height: auto !important;\n  text-align: center;\n}\n\n.add-cursor{\n  cursor: pointer;\n}\n\n.nav-big-header{ \n  height: 5.5rem;\n  line-height: normal;\n}\n\n.height-3{\n  height: 3.8rem !important;\n}\n\n.hcil-header-nave{\n  padding-top: 10px;\n  padding-left: 30px;\n  padding-right: 30px;\n}\n.navbar-brand{\n  padding: 15px 0 15px 55px;\n  float: left;\n  img{\n    width: 165px;\n  }\n  @media (max-width: 667.98px) {\n    padding: 10px 0 10px 15px;\n  }\n}\n\nnav {\n  .header-details {\n    width: 100%;\n    .search {\n      float: right;\n      margin: 12px;\n      border-right: 1px solid @textLight;\n      input {\n        background-color: transparent;\n        border: none; \n        border-radius: 5px;\n        color: @white;\n        padding: 5px 5px 5px 35px;\n        width: 100px;\n        outline: none;\n        margin-right: 12px;\n        background-image: url('/assets/images/ico_search.svg');\n        background-repeat: no-repeat;\n        background-size: 16px;\n        background-position: 8px center;\n      }\n      ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */\n        color: @white;\n        opacity: 1; /* Firefox */\n        font-size: 14px;\n      }\n      input:not(:placeholder-shown) {\n        background-color: @bgLight;\n        width: 350px;\n        margin-right: 12px;\n      }\n\n      &:hover {\n        input {\n          background-color: @bgLight;\n          width: 350px;\n          margin-right: 12px;\n          transition: 0.75s;\n        }\n      }\n    }\n    .usermenu {\n      float: right;\n      .dropdown-toggle {\n        background-color: transparent;\n        color: @white;\n        font-size: 16px;\n        text-transform: capitalize;\n        opacity: 0.75;\n        padding: 10px;\n        line-height: 16px;\n        outline: none;\n        span {\n          font-size: 12px;\n        }\n        &:hover {\n          opacity: 1;\n        }\n        &:focus {\n          border-color: transparent;\n          box-shadow: none;\n        }\n      }\n      .dropdown-menu {\n        background-color: @bgLight;\n        padding: 0;\n        .dropdown-item {\n          color: @white;\n          padding: 8px 10px;\n          font-size: 14px;\n          &:hover {\n            background-color: @brand-color;\n          }\n        }\n      }\n    }\n  }\n}\n.sub-nav {\n  height: 40px;\n  top: 100px;\n  left: 0;\n  position: absolute;\n  z-index: 1029;\n  width: 100%;\n  background-color: @bgLight;\n  .dashboard-log {\n    cursor: pointer;\n    img {\n      float: left;\n      width: 16px;\n      margin: 13px 8px 0 32px;\n    }\n    h5 {\n      color: @brand-color;\n      font-size: 18px;\n      float: left;\n      margin: 11px 0;\n    }\n  }\n  .dashboard-menu {\n    ul {\n      float: left;\n      padding: 0 2px;\n      li {\n        color: @white;\n        list-style: none;\n        display: inline-block;\n        margin: 0 5px;\n        padding: 13px 1px;\n        border-bottom: 3px solid transparent;\n        font-size: 12px;\n        cursor: pointer;\n        &:hover {\n          color: @brand-color;\n          border-bottom: 3px solid @brand-color;\n        }\n        &.selected {\n          color: @brand-color;\n          border-bottom: 3px solid @brand-color;\n        }\n      }\n    }\n  }\n}\n\n.bar_div {\n  display: block;\n  width: 100%;\n  height: 50px;\n  position: absolute;\n  left: 0; \n  top: 64px;\n  background-color: #cc0000;\n}\n\n.telephony_frame {\n  width: 100%;\n  height: 40px;\n  right: 0;\n  border: unset;\n}\n\n.crm_frame {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  border: none;\n}\n\n.bar_button {\n  background-color: #3C8DBC;\n  color: white;\n  border: solid black 0px;\n  cursor: pointer;\n  padding: 4px;\n  font-weight: bold;\n}\n\ntable {\n  border-collapse: collapse;\n  width: 100%;\n  border-radius: 10px 10px 0 0;\n  box-shadow: 0 -1px 22px -1px #C6C6C6;\n  box-sizing: border-box;\n}\n\ntd {\n  text-align: left;\n  padding: 8px;\n}\n\nth {\n  text-align: center;\n  padding: 8px;\n  background-color: #3C8DBC;\n  color: white;\n  border-radius: 10px 10px 0 0;\n  box-shadow: 0 -1px 22px -1px #C6C6C6;\n  box-sizing: border-box;\n}\n\ntr:nth-child(even) {\n  background-color: #f2eded;\n}\n\ntr:nth-child(odd) {\n  background-color: #e8e3e3;\n}\nbutton.dlrtkt {\n  background: none;\n  color: #ffffff;\n  border: none;\n  margin-top: 9px;\n  margin-left: 12px;\n  font-size: 12px;\n}\n.dashboard_dealer_ticket {\n  float: left;\n  font-size: 12px;\n  padding: 3px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
